<div class="contact-content">

  <h3 class="contact-info-heading">My Contacts</h3>
  <hr class="contact-info-divider">
  <div *ngFor="let manager of (managers$ | async); let i = index;"
    [ngClass]="(managers$ | async)?.length !== i + 1 ? 'row contact-row mos-u-spacer--margin-bottom-sm' : 'row contact-row'">
    <div *ngIf="(manager?.profileImageId)" class="columns small-12 medium-1">

      <atlas-avatar *ngIf="loading[manager?.profileImageId]" [imgAlt]="'Profile Image'">
        {{manager.firstName.substring(0, 1)}}{{manager.lastName.substring(0, 1)}}
      </atlas-avatar>
      <img *ngIf="(profileImageDataUrl$[manager?.profileImageId] | async) as profileImageDataUrl"
        [hidden]="loading[manager?.profileImageId]" class="profileImage" (load)="onLoad(manager?.profileImageId)"
        (error)="onLoadError(manager?.profileImageId)" [src]="profileImageDataUrl" />
    </div>
    <div *ngIf="!(manager?.profileImageId)" class="columns small-12 medium-1">
      <atlas-avatar *ngIf="!(manager?.profileImageId)" [imgAlt]="'Profile Image'">
        {{manager.firstName.substring(0, 1)}}{{manager.lastName.substring(0, 1)}}
      </atlas-avatar>
    </div>
    <div class="columns medium-2 small-12">
      <h4>{{manager.lastName}}, {{manager.firstName}}</h4>
    </div>
    <div class="columns medium-9 small-12 contact-details">
      <h5>
        <atlas-icon [icon]="'icon-phone-24'" [size]="'large'" [alt]="'phone'"></atlas-icon>

        {{manager.phone}}
      </h5>
      <h5>
        <atlas-icon [icon]="'icon-mail-24'" [size]="'large'" [alt]="'email'"></atlas-icon>
        <a [href]="'mailto:' + manager.username">{{manager.username}}</a>
      </h5>
    </div>
  </div>
</div>